<div class="form-group mt-3 fill-dark-blue"> 
  Referrals in the Opportunity phase
</div>
<ng-table [rows]="rows" [columns]="columns"></ng-table>